module.exports = __webpack_public_path__ + "img/blog_19.6a450f34.jpeg";